import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Multicast
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t, t2 } from '@/@core/libs/i18n/utils'
import { $themeConfig } from '@themeConfig'

export default function tableMulticast() {
  // Use toast
  const toast = useToast()

  const refMulticastTable = ref(null)
  const lineOa = computed(() => store.state.lineapi.lineOa)

  const msgMulticast = {
    errorfetch: t2('Error fetching {module} list', { module: t('Multicast') }),
    id: `${t('Create Date/Time')} » ${t('ID')}`,
    name: `${t('Name')} » ${t('Audience')}`,
    schedule: `${t('Schedule')} » ${t('Schedule Date/Time')} » ${t('Sent')} / ${t('Reached')}`,
    state: `${t('State.')} » ${t('Send Date/Time')}`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: msgMulticast.id },
    { key: 'name', sortable: true, label: msgMulticast.name },
    { key: 'schedule', sortable: false, label: msgMulticast.schedule },
    { key: 'state', sortable: false, label: msgMulticast.state },
    { key: 'actions', label: msgMulticast.actions },
  ]

  const filterList = JSON.parse(localStorage.getItem(`${$themeConfig.app.session}-filter-multicast`))
  const perPage = ref((filterList != null && filterList.perPage != null) ? filterList.perPage : 10)
  const totalMulticasts = ref(0)
  // const currentPage = ref((filterList != null && filterList.page != null) ? filterList.page : 1)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref((filterList != null && filterList.q != null) ? filterList.q : '')
  const sortBy = ref((filterList != null && filterList.sortBy != null) ? filterList.sortBy : 'id')
  const isSortDirDesc = ref((filterList != null && filterList.sortDesc != null) ? filterList.sortDesc : true)
  const locale = ref('th')

  const dataMeta = computed(() => {
    const localItemsCount = refMulticastTable.value ? refMulticastTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMulticasts.value,
    }
  })

  const refetchData = () => {
    if (refMulticastTable.value !== null) {
      refMulticastTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, locale], () => {
    refetchData()
  })

  const getListMulticast = (ctx, callback) => {
    const { id } = JSON.parse(lineOa.value)
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      language: locale.value,
      lineOaId: id,
    }
    store
      .dispatch('multicast-store/getListMulticast', params)
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalMulticasts.value = total
        localStorage.setItem(`${$themeConfig.app.session}-filter-multicast`, JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgMulticast.errorfetchMulticast,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  return {
    getListMulticast,
    tableColumns,
    perPage,
    currentPage,
    totalMulticasts,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    locale,
    refMulticastTable,
    filterList,

    refetchData,
  }
}
